/**
 * DESCARGA DEL PAQUETE DE IDIOMA QUE **NO** VIAJA DENTRO DEL BUNDLE.
 *
 * ╔═══════════════════════════════════════════════════════════════════════════╗
 * ║ El español viaja SIEMPRE dentro de `main.js` (lo importa `i18n.js` de      ║
 * ║ forma estática). Aquí solo vive el otro: el inglés, que se baja aparte y   ║
 * ║ solo cuando de verdad se necesita.                                        ║
 * ╚═══════════════════════════════════════════════════════════════════════════╝
 *
 * POR QUÉ ES UN MÓDULO APARTE Y NO UNA LÍNEA DENTRO DE `i18n.js`:
 * la decisión ("¿qué idioma?") y la descarga ("tráemelo") son dos cosas
 * distintas y solo la primera es nuestra. Separadas, las pruebas pueden
 * afirmar que con el teléfono en español **no se llama a este archivo**, que es
 * justo el ahorro que se persigue; si la descarga viviera pegada a la decisión,
 * la única forma de comprobarlo sería mirar el bundle compilado.
 *
 * POR QUÉ `import()` DE WEBPACK Y NO UN `fetch` A UN ARCHIVO DE `public/`:
 *   1. webpack le pone **hash de contenido** al nombre del chunk. Un archivo en
 *      `public/locales/en.json` NO lleva hash, y `firebase.json` cachea con
 *      `max-age=31536000` todo lo que termina en `.js` — o sea que el chunk
 *      hereda gratis el cacheo bueno Y el rompe-caché, mientras que el .json
 *      suelto se quedaría con el caché por defecto y, peor, una corrección de
 *      traducción podría no llegarle nunca a un cliente que ya lo tenga.
 *   2. El service worker de CRA (workbox) precachea los activos que emite
 *      webpack. El chunk entra en ese inventario solo; un archivo suelto de
 *      `public/` habría que declararlo a mano y mantenerlo a mano.
 *
 * El coste de esta vía es un viaje de ida y vuelta extra (~150 ms en 4G lenta)
 * para quien tiene el teléfono en inglés. Se acepta a propósito y está medido
 * en el informe: ese usuario descarga los MISMOS bytes que hoy, y a cambio el
 * hispanohablante —la inmensa mayoría en RD— deja de bajar 60 KB que no lee.
 */

/** Idiomas que hay que ir a buscar (el español no está: viaja en el bundle). */
export const LAZY_LANGS = ['en'];

/**
 * Trae el paquete de traducciones de `lng`.
 * @returns {Promise<object>} el objeto de traducciones.
 * @throws si el idioma no se descarga aparte o si la red falla.
 */
export function loadLocale(lng) {
  if (lng !== 'en') {
    return Promise.reject(new Error(`localeLoader: "${lng}" no se descarga aparte`));
  }
  return import(/* webpackChunkName: "locale-en" */ './locales/en.json')
    .then((mod) => mod.default || mod);
}
